import { bankId, email, maxLength, minLength, phoneNumber } from '../../../rules';
import { useLocale } from '../../../composables/useLocale';

export const useValidator = () => {
  const { t } = useLocale();

  const mailLike = () => [minLength(3, t), email(t), maxLength(255, t)];
  return {
    mailLike,
    swedishPhoneNumber: (t: (key: string, ...params: unknown[]) => string) => [phoneNumber(t)],
    bankId: () => [bankId(t)],
    other: () => [minLength(3, t), maxLength(255, t)],
  };
};
